{
  "close": "Stäng"
}
